import React, { Component } from 'react';

import IconVisa from 'react-icons/lib/fa/cc-visa';
import IconAmex from 'react-icons/lib/fa/cc-amex';
import IconMasterCard from 'react-icons/lib/fa/cc-mastercard';
import IconDiscover from 'react-icons/lib/fa/cc-discover';
import IconJCB from 'react-icons/lib/fa/cc-jcb';
import IconDinersClub from 'react-icons/lib/fa/cc-diners-club';
import IconCreditCard from 'react-icons/lib/fa/credit-card';


// stripe card "brand" could be any of the following
const CardBrandsIcons= {
  "Visa": IconVisa,
  "American Express": IconAmex,
  "MasterCard": IconMasterCard,
  "Discover": IconDiscover,
  "JCB": IconJCB,
  "Diners Club": IconDinersClub,
  "Unknown": IconCreditCard,
}
class PaymentInfo extends Component {
  render() {
    const {
      brand,
      last4,
      exp_month,
      exp_year,
    } = this.props.source || {};

    const { color } = this.props;

    const CardIcon = CardBrandsIcons[brand || "Unknown"];
    const month = (Number(exp_month) < 10) ? `0${exp_month}` : String(exp_month);
    const year = String(exp_year).slice(-2);

    return (
      <div className="PaymentInfo" style={{ color: color }}>
        <span className="PaymentInfo-brand"><CardIcon /></span>
        <span className="PaymentInfo-cardNumber">
          <span className="hidden-xs">**** **** </span>**** {last4}
        </span>
        <span className="PaymentInfo-expiry">exp {month}/{year}</span>
      </div>
    );
  }
};

export default PaymentInfo;


// WEBPACK FOOTER //
// ./src/components/Payment/PaymentInfo.js